import { NextPage } from 'next';
import { redirect } from 'next/navigation';
import { ErrorBoundaryWithSuspense } from '../../../layouts/ErrorBoundary/ErrorBoundaryWithSuspense';
import { TradeControllerVariants } from '../../utils';
import { allTradeOperations } from './utils/tradeOperations';
import { getAssetTradeUrl } from '../../../route-builders';
import { TradeController } from './TradeController.server';
import { TradeSkeletons } from '../../Reusable/Skeletons';

export interface TradeControllerWithSuspenseProps {
  routeParams: Record<string, string>;
  searchParams?: Record<string, string>;
}

export const TradeControllerWithSuspense: NextPage<
  TradeControllerWithSuspenseProps
> = async ({ routeParams, searchParams }) => {
  if (
    allTradeOperations.includes(
      routeParams.operation as TradeControllerVariants,
    ) === false
  ) {
    redirect(getAssetTradeUrl(routeParams.assetId, { type: 'buy' }));
  }

  return (
    <ErrorBoundaryWithSuspense
      fallbackOrSkeleton={
        routeParams.operation === 'savings' ? (
          <TradeSkeletons.TradeSkeletonWithSavings />
        ) : (
          <TradeSkeletons.TradeSkeleton />
        )
      }
    >
      <TradeController
        routeParams={routeParams}
        searchParams={searchParams}
        key={`TradeController-${JSON.stringify(routeParams)}-${JSON.stringify(searchParams)}`}
      />
    </ErrorBoundaryWithSuspense>
  );
};
